import type { ReactNode } from 'react'
import { Table2 } from 'lucide-react'

interface ReportEmptyStateProps {
  message: string
  description?: ReactNode
}

export function ReportEmptyState({ message, description }: ReportEmptyStateProps) {
  return (
    <div className="flex flex-col items-center gap-3 rounded-lg border border-dashed bg-muted/20 px-4 py-16 text-center">
      <span className="flex h-12 w-12 items-center justify-center rounded-full bg-muted">
        <Table2 className="h-5 w-5 text-muted-foreground" aria-hidden />
      </span>
      <p className="text-sm font-medium text-foreground">{message}</p>
      {description ? (
        <div className="max-w-md text-xs text-muted-foreground">{description}</div>
      ) : null}
    </div>
  )
}
